<template>
    <div class="companies-card">
      <img src="/images/promo/connect-features/companies-card.svg" alt="Companies card" />
    </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">

</style>
